/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type RecoveryCodeList_recoveryCodes$ref = any;
type RecoveryCodes_totp$ref = any;
type TwoFactorConfigure_viewer$ref = any;
type TwoFactorDelete_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type TwoFactor_viewer$ref: FragmentReference;
export type TwoFactor_viewer = {|
  +permissions: {|
    +totpConfigure: {|
      +allowed: boolean,
      +code: ?string,
      +message: ?string,
    |}
  |},
  +totp: ?{|
    +id: string,
    +recoveryCodes: {|
      +codes: $ReadOnlyArray<{|
        +code: string,
        +consumed: boolean,
      |}>,
      +$fragmentRefs: RecoveryCodeList_recoveryCodes$ref,
    |},
    +$fragmentRefs: RecoveryCodes_totp$ref,
  |},
  +$fragmentRefs: TwoFactorConfigure_viewer$ref & TwoFactorDelete_viewer$ref,
  +$refType: TwoFactor_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "TwoFactor_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "TwoFactorConfigure_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TwoFactorDelete_viewer",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "permissions",
      "storageKey": null,
      "args": null,
      "concreteType": "ViewerPermissions",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "totpConfigure",
          "storageKey": null,
          "args": null,
          "concreteType": "Permission",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "allowed",
              "args": null,
              "storageKey": null
            },
            v0,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "message",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "totp",
      "storageKey": null,
      "args": null,
      "concreteType": "TOTP",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "RecoveryCodes_totp",
          "args": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "recoveryCodes",
          "storageKey": null,
          "args": null,
          "concreteType": "RecoveryCodeBatch",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "RecoveryCodeList_recoveryCodes",
              "args": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "codes",
              "storageKey": null,
              "args": null,
              "concreteType": "RecoveryCode",
              "plural": true,
              "selections": [
                v0,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "consumed",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e3c804b3372143e71e1440058361bc58';
module.exports = node;
